import { trimBasenameAndNetworkFromUrlPath } from '@ms/yammer-libs-url-path-support';

export const getRoutePathFromUrl = (url: string): string => {
  const pathname = new URL(url).pathname;

  return trimBasenameAndNetworkFromUrlPath(pathname);
};

export const getRoutePathAndQueryFromUrl = (url: string): string => {
  const urlObj = new URL(url);
  const pathnameAndQuery = urlObj.pathname + urlObj.search;

  return trimBasenameAndNetworkFromUrlPath(pathnameAndQuery);
};
